import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import Seo from "../components/seo"

const IndexPage = () => (
  <Layout>
    <Seo title="Home" />
    <h1>Hi people</h1>
    <p>Welcome to your new Gatsby site.</p>
    <p>Now go build something great.</p>
    <StaticImage
      src="../images/gatsby-astronaut.png"
      width={300}
      quality={95}
      formats={["AUTO", "WEBP", "AVIF"]}
      alt="A Gatsby astronaut"
      style={{ marginBottom: `1.45rem` }}
    />
    <p>
      <Link to="https://blog.sebwink.net/">Blog</Link> <br />
      <Link to="https://github.com/sebwink/">GitHub</Link> <Link to="https://code.sebwink.net/">Pages</Link> <br />
      <Link to="https://site.sebwink.net/">Clone</Link> <br />
    </p>
  </Layout>
)

export default IndexPage
